import { Label } from '@ui/Label';
import { Box, CardHeader, Typography } from '@mui/material';
import React from 'react';

export const PaywallCardHeader = ({
  title,
  subheader,
  chipLabel,
}: {
  title: string;
  subheader: string;
  chipLabel?: string;
}) => {
  return (
    <CardHeader
      title={
        <Box
          sx={{
            display: 'flex',
            gap: 4,
          }}
        >
          <Typography
            variant="h3"
            sx={{
              paddingBottom: 4,
            }}
          >
            {title}
          </Typography>
          {chipLabel && (
            <Label
              color="primary"
              label={chipLabel.toLocaleUpperCase()}
              slotProps={{ label: { sx: { paddingTop: 0.5 } } }}
            />
          )}
        </Box>
      }
      subheader={subheader}
      slotProps={{ subheader: { variant: 'subtitle2', textTransform: 'none' } }}
      sx={{ minHeight: 120 }}
    />
  );
};
